import { useAppDispatch } from "reduxFiles/hooks";
import { setUser, setTokens } from "reduxFiles/slices/authSlice";
import { ConfirmSignUpResponse, LoginResponse } from "types/authTypes";

export const useAuthTokens = () => {
  const dispatch = useAppDispatch();

  const saveTokensAndUser = (
    response: LoginResponse | ConfirmSignUpResponse
  ) => {
    dispatch(
      setTokens({
        accessToken: response.accessToken,
        refreshToken: response.refreshToken,
        tokenType: response.tokenType,
      })
    );

    dispatch(setUser(response.user));
  };

  return { saveTokensAndUser };
};

export default useAuthTokens;
